<template>
  <div v-if="mode==='list'" style="margin-top: 30px;">
    <template v-if="items.length > 0">
      <p><a href="/news/create" class="button3">Добавить</a></p>
      <easy-data-table
          :headers="headers"
          :items="items"
          style="margin-top: 30px;"
      >

        <template #item-rubric="item">
          <div v-for="(rubric,index) in item.rubric" :key="index">
            <p>{{ rubric.title }}</p>
          </div>
        </template>

        <template #item-image="item">
          <img v-if="item.image.length > 0" style="width: 200px" :src="item.image">
        </template>


        <template #item-created="item">
          {{ formatedDate(item.created) }}
        </template>

        <template #item-actions="item" >
          <a :href="'/news/create/'+item.id" style="margin-right: 20px; font-size: 14px;"><i class="far fa-edit"></i></a>
          <a @click.prevent="deleteItem(item.id)" style="font-size: 14px;"><i class="fas fa-trash"></i></a>
        </template>
      </easy-data-table>
    </template>
    <div v-else-if="isLoading">
      <BaseLoader></BaseLoader>
    </div>
    <template v-else>
      <p><a href="/news/create" class="button3">Добавить</a></p>
      <p style="margin-top: 30px;">Ничего не найдено</p>
    </template>
  </div>
  <div v-else-if="mode==='edit'">
    <p style="margin-top: 30px;"><a @click.prevent="mode='list'">К списку</a></p>
    <form @submit.prevent="updateItem">
      <BaseInput
          v-model="item.title"
          label="Название рубрики"
      ></BaseInput>
      <p><button class="button3" style="cursor:pointer;" type="submit">Сохранить</button></p>
    </form>
  </div>

</template>
<script>

import axios from "axios";
import moment from "moment";

import BaseInput from "./Base/BaseInput3";
import BaseLoader from "./Base/BaseLoader";

const entity = 'news';

export default {
  components: {
    BaseInput,
    BaseLoader
  },
  data() {
    return {
      headers: [
        { text: "Название", value: "title" },
        { text: "Рубрики", value: "rubric" },
        { text: "Обложка", value: "image" },
        { text: "Дата публикации", value: "created" },
        { text: "Действия", value: "actions", width: 200 },
      ],
      items: [],
      mode: 'list',
      item: {
        id: '',
        title: '',
      },
      isLoading: true
    }
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const areaResponse = await axios.get('/api/'+entity+'?order[id]=desc', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      this.items = areaResponse.data;
      this.isLoading = false;
    },
    createItem() {
      axios.post('/api/'+entity, {
        'title': this.item.title
      }).then(() => {
        this.item.title = '';
        this.mode = 'list'
        this.getData();
      })
    },
    async editItem(id) {
      this.mode = 'edit';
      this.isLoading = true;
      const areaResponse = await axios.get('/api/'+entity+'/'+id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      this.item = areaResponse.data;
      this.isLoading = false;
    },
    updateItem() {
      axios.patch('/api/'+entity+'/'+this.item.id, {
        'title': this.item.title
      }, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      }).then(() => {
        this.item.title = '';
        this.mode = 'list'
        this.getData();
      })
    },
    deleteItem(id) {
      axios.delete('/api/'+entity+'/'+id).then(()=>{
        this.getData();
      })
    },
    formatedDate(date) {
      return moment(date).format('YYYY-MM-DD h:mm:ss');
    }
  },
  computed: {

  }
}
</script>
<style>
.button3 {
  cursor: pointer;
}
</style>